import { Wizard, PageWrap } from "@vwfs-bronson/bronson-react";

interface Props {
  currentStepTitle: string;
  noFunctionalSteps: { title: string }[];
  currentStepIndex: number;
}

export const WizardNavigation = ({
  currentStepTitle,
  currentStepIndex,
  noFunctionalSteps,
}: Props) => {
  return (
    <>
      <PageWrap size="small">
        <div className="u-pv">
          <Wizard
            collapsedText={currentStepTitle}
            collapseBreakpoint="s"
            noInteraction
            stepLabels={{
              doneLabel: "Erledigt",
              errorLabel: "Fehler",
              notDoneLabel: "Nicht abgeschlossen",
              noInteractionLabel: "Keine Interaktion",
            }}
          >
            <Wizard.Item key={currentStepIndex} active={true}>
              {currentStepTitle}
            </Wizard.Item>
            {noFunctionalSteps.map((step: any, index: any) => {
              return <Wizard.Item key={index}>{step.title}</Wizard.Item>;
            })}
          </Wizard>
        </div>
      </PageWrap>
      <hr className="u-mv-small" />
    </>
  );
};
